import styled from "styled-components";

export const CampaignRow = styled.div`
  display: grid;
  grid-template-columns: 20px 32px minmax(200px, 330px) 160px 240px 160px;
  grid-gap: 20px;
  justify-content: start;
  align-items: center;
`;